import { PROXY_TRAVEL } from '@/constants'
import request from '@/utils/request'
import { isMyApp } from '@/utils/util'

const headers = {
  'X-Halo-App': isMyApp ? 'app-travel' : 'app-travel-h5',
}

export function detail(id) {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: `/api/app-travel-mini/v1/destination/service/${id}`,
    params: { id },
  })
}

export function track(desc) {
  if (window.location.href.match(/weddingee/)) return
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: '/api/app-travel-mini/v1/crm/track',
    method: 'post',
    data: { track_desc: desc },
  })
}

export function halls(hotel_id) {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: `/api/app-travel-mini/v2/destination/hotel/${hotel_id}/hall`,
  })
}

export function toggleCollect(record_id) {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: '/api/app-travel-mini/v1/collect',
    method: 'post',
    params: { record_id },
  })
}

export function collectList() {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: '/api/app-travel-mini/v1/collect',
  })
}

export function serviceList({ hotel_id = '', is_merchant } = {}) {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: '/api/app-travel-mini/v1/destination/service',
    params: { hotel_id, is_merchant },
  })
}

export function hallDetail(id, is_merchant) {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: `/api/app-travel-mini/v1/hotel/hall/${id}`,
    params: { is_merchant },
  })
}

export function hallDetail2(id) {
  return request({
    baseURL: PROXY_TRAVEL,
    headers,
    url: `/api/app-travel-mini/v2/hotel/hall/${id}`,
    params: { id },
  })
}
